import { getSessionToken } from '@/lib/auth'
import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'

const EntrarRoute = lazyRouteComponent(
  () => import('@/features/entrar/Entrar'),
  'Entrar'
)

export const Route = createFileRoute('/entrar')({
  beforeLoad: () => {
    if (getSessionToken()) {
      throw redirect({ to: '/conta' })
    }
  },
  component: EntrarRoute,
})
